import React from 'react'
import UrgencyLabel from 'components/Luxkit/Label/UrgencyLabel'
import { partitionBy } from 'lib/array/arrayUtils'
import PromotionLabel from 'components/Luxkit/Label/PromotionLabel'
import LineAwardIcon from 'components/Luxkit/Icons/line/LineAwardIcon'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import { getUrgencyTagVariant } from 'lib/tours/tourUtils'

const tagToComponentMap = {
  bestseller: <PromotionLabel key="bestseller" variant="default" icon={<LineAwardIcon />} data-testid="UrgencyLabel">
    Bestseller
  </PromotionLabel>,
  bestofthedecade: <PromotionLabel key="bestofthedecade" variant="default" icon={<LineAwardIcon />} data-testid="UrgencyLabel">
    Best of the Decade
  </PromotionLabel>,
  bestof2023: <PromotionLabel key="bestof2023" variant="default" icon={<LineAwardIcon />} data-testid="UrgencyLabel">
    Best of 2023
  </PromotionLabel>,
}
const manuallyHandledTags = new Set(Object.keys(tagToComponentMap))

interface Props {
  className?: string;
  tags: Array<string>;
}

function TourV2UrgencyTags(props: Props) {
  const [manualTags, autoTags] = partitionBy(props.tags, (tag) => manuallyHandledTags.has(tag.toLowerCase()))
  if (manualTags.length === 0 && autoTags.length === 0) {
    return null
  }

  return <LabelGroup className={props.className}>
    {manualTags
      .map((tag) => tagToComponentMap[tag.toLowerCase()])
      .concat(
        autoTags.map((tag) => <UrgencyLabel key={tag} variant={getUrgencyTagVariant(tag)}>{tag}</UrgencyLabel>),
      )}
  </LabelGroup>
}

export default TourV2UrgencyTags
